// extracted by mini-css-extract-plugin
module.exports = {"panel-head":"CJf14FFjgjOZUvNnFeik6","icon-container":"_1IKRlFnsBsTZOX5350v99D","input-ecommerce":"_281sWWIDeJvfunzqNRdiCz"};